import { getIdentifiedBrowserName } from './general';

window.addEventListener('error', (e) => {
  const errorMsg = {
    url: window.location.href.split('#')[0],
    message: e.message,
    error: e.error,
    defaultPrevented: e.defaultPrevented,
    filename: e.filename,
    lineno: e.lineno,
    colno: e.colno,
    target: e.target?.toString(),
    currentTarget: e.currentTarget?.toString(),
    ua: navigator.userAgent,
    browserName: getIdentifiedBrowserName(),
    path: (e as unknown as { path: NonNullable<unknown>[] | undefined }).path?.map?.(element => element.toString()) ?? [],
    stack: (e as unknown as { stack: string | undefined }).stack?.split?.('\n') ?? [],
    outerHTMLTarget: (e.target as HTMLElement | null)?.outerHTML,
    outerHTMLCurrentTarget: (e.currentTarget as HTMLElement | null)?.outerHTML
  };

  fetch('https://tools.rbb-online.de/tools-service/api/error-collector', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(errorMsg)
  }).then();
});
